// The seam between Criar conta and whatever creates accounts. The screen
// needs one call and three answers it can show; keeping it behind a
// function type lets the screen be tested without Firebase.

import type { SignUpDraft } from "./signUpForm";

/** Why a sign-up failed, as the screen tells the athlete. */
export type SignUpFailure = "email-in-use" | "email-invalid" | "failed";

export class SignUpError extends Error {
  constructor(readonly failure: SignUpFailure) {
    super(`sign-up failed: ${failure}`);
    this.name = "SignUpError";
  }
}

/** Creates the account and opens its session; rejects with a SignUpError. Takes a normalized draft. */
export type SignUp = (draft: SignUpDraft) => Promise<void>;

/** Past this, the screen gives up waiting (SPEC-14: "max 10 s"). */
export const SIGN_UP_TIMEOUT_MS = 10_000;
